/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { Directive } from '@angular/core';

@Directive({
  selector: 'sbb-label',
  host: {
    class: 'sbb-label',
  },
})
export class SbbLabel {}
